<template>
    <div class="container lang">
        <section class="bc_section01 classon">
            <div class="bc_video">
                <video src="@/assets/resource/video/blood-video.mp4" autoplay muted loop></video>
            </div>
            <div class="bc_section01__text pc-none">
                <h3 class="bc_section01--tit">
                    <sub>Ихуа их сургуулийн Цусны хавдрын эмнэлэг</sub>
                    Эдгэршгүй байдлаас бүрэн эдгэрэх хүртэл
                </h3>
                <p class="bc_section01--p">
                    Нарийвчилсан, хувь хүн бүрт тохирсон эмчилгээ хийж, гэр бүлийн асаргаа мэт цогц тусламж үйлчилгээ
                </p>
                
            </div>
            <ul class="bc_section01__btn-wrap">
                <li class="bc_section01__btn-item">
                    <router-link to="/mn/international/appointment" class="bc_section01--btn">томилгоо</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/mn/international/treatment" class="bc_section01--btn">Олон улсын үзлэг эмчилгээ</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/mn/international/staff" class="bc_section01--btn">Ажилтан</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/mn/intro/directions" class="bc_section01--btn">Зам заагч</router-link>
                </li>
            </ul>
            <div class="visual_image--text-wrap">
                <img src="/resource/img/main/visual_image--text.png" class="visual_image--text" alt="">
            </div>
        </section>
        <section class="bc_section02">
            <div class="inner classon">
                <div class="bc_section__title">
                    <h3 class="bc_section__title--tit">
                        <sub>
                            <span>F</span>
                            <span>r</span>
                            <span>o</span>
                            <span>m</span>
                            &nbsp;
                            <span>I</span>
                            <span>n</span>
                            <span>t</span>
                            <span>r</span>
                            <span>a</span>
                            <span>c</span>
                            <span>t</span>
                            <span>a</span>
                            <span>b</span>
                            <span>l</span>
                            <span>e</span>
                            &nbsp;
                            <span>T</span>
                            <span>o</span>
                            &nbsp;
                            <span>C</span>
                            <span>o</span>
                            <span>m</span>
                            <span>p</span>
                            <span>l</span>
                            <span>e</span>
                            <span>t</span>
                            <span>e</span> 
                            &nbsp;
                            <span>C</span>
                            <span>u</span>
                            <span>r</span>
                            <span>e</span>
                        </sub>
                        <span>
                            Цусны хавдрын эмнэлэгийн эмч нарын танилцуулга
                        </span>
                    </h3>
                </div>

                <!-- 720 이하부터 나오는 모바일 스와이프 -->
                <div class="bc_section02__list-swiper" v-if="bc_section02_mo">
                    <swiper class="bc_section02__list"
                            :slidesPerView="1.7"
                            :slidesPerGroup="1"
                            :loop="true"
                            :spaceBetween="24"
                            :centeredSlides="true"
                            :modules="modules"
                            :pagination="paginationConfig"
                            :navigation="{
                                nextEl: '.bc_section02--swiper-arrow.next',
                                prevEl: '.bc_section02--swiper-arrow.prev'
                            }"
                        
                        >
                        <swiper-slide class="bc_section02__item" v-for="doctor in doctorList" :key="doctor">
                            <div class="bc_section02__item-wrap">
                                <div class="bc_section02__item__img-box">
                                    <img class="bc_section02__item--img" :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs">
                                    <div class="bc_section02__hover">
                                        <h4 class="bc_section02__item--tit">{{doctor.drNameGlb}} <br>профессор</h4>
                                        <p class="bc_section02__item--text">{{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}</p>
                                        <div class="bc_section02__hover__btn-wrap">
                                            <a class="bc_section02__hover--btn" :href="`/mn/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank" >Information</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <button class="bc_section02--swiper-arrow next"></button>
                    <button class="bc_section02--swiper-arrow prev"></button>
                </div>
                <ul class="bc_section02__list" v-else>
                    <li class="bc_section02__item" v-for="doctor in doctorList" :key="doctor">
                        <div class="bc_section02__item-wrap">
                            <div class="bc_section02__item__img-box">
                                <img class="bc_section02__item--img" :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs">
                                <div class="bc_section02__hover">
                                    <h4 class="bc_section02__item--tit">{{doctor.drNameGlb}} <br>профессор</h4>
                                    <p class="bc_section02__item--text">{{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}</p>
                                    <div class="bc_section02__hover__btn-wrap">
                                        <a class="bc_section02__hover--btn" :href="`/mn/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank" >Information</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="bc_section03">
            <div class="bc_section03__text-bg classon">
                <div class="bc_section03__text-bg01">
                    <img src="/resource/img/main/bc_section03-text-bg01.png" alt="">
                    <img src="/resource/img/main/bc_section03-text-bg01.png" alt="">
                </div>
                <div class="bc_section03__text-bg02">
                    <img src="/resource/img/main/bc_section03-text-bg02.png" alt="">
                    <img src="/resource/img/main/bc_section03-text-bg02.png" alt="">
                </div>
            </div>
            <div class="inner classon">
                <div class="bc_section03--bg-text">

                </div>
                <ul class="bc_section03__list classon">
                    <li class="bc_section03__item">
                        <h3 class="bc_section__title--tit classon">
                            <span class="font-poppins">Яагаад ?</span>
                            <strong>
                                <b class="main-bg">
                                    <span>
                                        Ихуа их сургуулийн эмнэлэг вэ
                                    </span>
                                </b>
                            </strong>
                        </h3>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro01')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item01.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                Цусны салбарын мэргэшсэн эмч мэргэжилтнүүдээр бүрэн хангагдсан, цусны хавдрын салбар тус бүрийн төв ажиллуулдаг  
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro02')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item02.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                24 цагийн турш цусны хавдрын мэргэжлийн эмч өвчтөнд тусламж үйлчилгээ үзүүлнэ
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro03')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item03.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                Бусад байгууллагуудаас ялгагдах чанар нь цусны хавдрын төрөлжсөн төвүүдийг ажиллуулдаг
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro04')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item04.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                Солонгос улсад анх удаа цусны хавдрын гэр бүлийн тусламж үйлчилгээний төвийг ажиллуулж байна
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item">
                        <h3 class="bc_section__title--tit classon">
                            <div style="display: flex;">
                                <span class="c-main30">
                                    Ихуа их сургуулийн Цусны хавдрын эмнэлэгийн энэ зүйл нь өөр юм. 
                                </span>
                            </div>
                        </h3>
                    </li>
                </ul>
            </div>
        </section>
    </div>
    
    <en_FirstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
    <en_AlarmTalkPopup :popupVisible="alarmVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
</template>

<script>
    import { ref } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';
    import 'swiper/css/pagination';
    import 'swiper/css/thumbs';
    import 'swiper/css/grid';
    import { Pagination, Navigation, Thumbs, FreeMode, EffectFade, Grid } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            const thumbsSwiper = ref(null);
            const setThumbsSwiper = (swiper) => {
                thumbsSwiper.value = swiper;
            };
            return {
                thumbsSwiper,
                setThumbsSwiper,
                modules: [Pagination, Navigation, Thumbs, FreeMode, EffectFade, Grid],
            };
        },
        data() {
            return {
                paginationConfig: {
                    type: 'custom',
                    renderCustom: (swiper, current, total) => {
                        // 두 자릿수 형식으로 포맷팅
                        const formattedCurrent = current.toString().padStart(2, '0');
                        const formattedTotal = total.toString().padStart(2, '0');
                        return `<span>${formattedCurrent}</span> / <span>${formattedTotal}</span>`;
                    },
                    clickable: true
                },
                main_popup: true,
                doctorList: [],
                thanksList: [],
                tvList: [],
                allList: [],
                newsList: [],
                noticeList: [],
                viewBoardName: 'all',
                viewList: [],
                drSids: '1019616,1001808,1002748,1015451,1022642,1005698',
                bc_section02_mo: false,
            };
        },
        methods: {
            goArticle(article){
                const url = `/${this.$store.getters.getLang}/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`
                window.open(url, '_blank')
            },
            goIntro(id){
                const url = '/mn/intro/intro#' + id
                console.log(url)
                location.href = url
            },
            dateNumToStr(num,dot){
                const year = new Date(num).getFullYear();
                const month = new Date(num).getMonth() + 1;
                const date = new Date(num).getDate();
                return {
                    'yearmonth': `${year}${dot}${month >= 10 ? month : '0' + month}`,
                    'date': `${date >= 10 ? date : '0' + date}`
                }
            },
            showList(board){
                this.viewBoardName = board
                this.viewList = this[board + 'List']
            },
            getMainBoardList() {
                const param = {
                    pageRow: 5
                }
                this.axios.get(this.api.article.main, {
                    params: param
                })
                    .then(res => {
                        const list = res.data
                        this.tvList = list['tv']
                        if(this.tvList?.length > 4){
                            this.tvList.length = 4
                        }
                        this.allList = list['all']
                        this.newsList = list['news']
                        this.noticeList = list['notice']
                        this.viewList = this.allList
                    })
            },
            hidePopup(param) {
                this[param] = false;
            },
            getMainBanner() {
                const param = {
                    hospId: this.$store.getters.getHost
                }
                this.axios.get(this.api.banner.main, {
                    params: param
                }).then(res => {
                    // 팝업
                    const popup = res.data.popup
                    this.popupCnt = popup.totCnt
                    this.popupList = popup.list

                    if(this.popupCnt > 0){
                        this.main_popup = true

                        const oneDay = 24 * 60 * 60 * 1000
                        const now = new Date().getTime()

                        const popupLastVisit = localStorage.getItem('popupTime_blood')
                        const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null
                        const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null

                        if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                            this.main_popup = false;
                        }
                    }else{
                        this.main_popup = false
                    }
                })
            },
            closePopup() {
                this.main_popup = false;
                const now = new Date().getTime()
                localStorage.setItem('popupTime_blood', now.toString())
            },
            main_popup_close() {
                this.main_popup = false;
            },
            initIntersectionObserver() {
                const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const target = entry.target;
                    if (entry.isIntersecting) {
                        target.classList.add('on');
                    }else{
                        // target.classList.remove('on');
                    }
                });
                }, {
                threshold: 0.3 // 요소가 30% 이상 보일 때
                });

                // 클래스 선택자 사용
                const elementsToObserve = document.querySelectorAll('.classon');
                
                elementsToObserve.forEach((element) => {
                observer.observe(element);
                });
            },
            getDoctorList(){
                const param = {
                    startIndex: 1,
                    pageRow: 100,
                    langCd: this.$store.getters.getLang,
                    hospId: this.$store.getters.getHost,
                    drSids: this.drSids
                }
                this.axios.get(this.api.doctor.doctorList, {params: param})
                .then(res => {
                    this.doctorList = res.data.doctorList
                    const drSidsArr = this.drSids.split(',')
                    this.doctorList.sort((a, b) => {
                        return drSidsArr.indexOf(a.drSid) - drSidsArr.indexOf(b.drSid)
                    });
                    // this.doctorList = this.$commonUtils.distinctList(arr, 'name')
                    this.bc_section02_mo = window.innerWidth <= 720;
                })
            },
            quickReservation(doctor) {
                this.$store.state.reserveStore.quickReserve = doctor
                this.$router.push('/mn/reserve/reservation')
            },
            getThanksList() {
                const boardNo = 10
                const params = {
                    hospId: this.$store.getters.getHost,
                    boardNo: boardNo,
                    startIndex: 1,
                    pageRow: 10,
                    title: '',
                    content: '',
                    searchKeyword: '',
                    item18: 'O'
                }
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                })
                    .then(res => {
                        this.thanksList = res.data.list
                    })
            },
            thanksPeoples(article) {
                let result = article.item1
                let doctorNames = []

                if (article.refDoctorList) {
                    for (let i of article.refDoctorList) {
                        doctorNames.push(`${i.deptNm}<br>${i.drName}`)
                    }
                }
                if (doctorNames.length > 0) {
                    if (result) {
                        result = "<span>" + result + "</span><br>" + doctorNames.join("<br>");
                    } else {
                        result = doctorNames.join('<br>');
                    }
                }

                return result
            },
        },
        mounted() {
            window.addEventListener('resize', this.checkWindowWidth);
            this.initIntersectionObserver();
            this.getMainBanner()
            this.getDoctorList()
            this.getMainBoardList()
            this.getThanksList()
        },
        beforeUnmount() {
          
        },
    }
</script>